<!-- Container.svelte -->
<script>
    export let parent_id;

    let tabpanel_id = parent_id + "-panel";


</script>
<div class="mb-4 ">
    <div id={tabpanel_id} aria-labelledby={parent_id} class="bg-ltgray p-3" role="tabpanel">
        <slot />
    </div>
</div>

<style>
</style>
